"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: !0
}), exports["default"] = void 0;

var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteral")),
    _graphqlTag = _interopRequireDefault(require("graphql-tag"));

function _templateObject() {
  var a = (0, _taggedTemplateLiteral2["default"])(["\n  query GetOrganisation($organisationId: String!)\n  {\n    getOrganisation(organisationId: $organisationId) {\n      name\n      brandingCoverImageKey\n      imageUrl\n      brandingDescription\n      billingEntityCode\n      creditBalance {\n        balance\n        creditTotal\n        rolloverBalance\n        rolloverTotal\n      }\n      package {\n        iconName\n        videoQuantity\n        slaTurnaround\n        userAllowance\n        storageAllowance\n        templatedFrom\n        creditType\n        subEnd\n        includedAddonTypes\n      }\n    }\n  }"]);
  return _templateObject = function _templateObject() {
    return a;
  }, a;
}

var GET_ORGANISATION_QUERY = (0, _graphqlTag["default"])(_templateObject()),
    _default = function _default(a) {
  return {
    query: GET_ORGANISATION_QUERY,
    module: "organisations",
    ignoreCache: !0,
    buildVariables: function buildVariables() {
      return {
        organisationId: a
      };
    }
  };
};

exports["default"] = _default;